import React, { FC, useContext, useEffect, useReducer, useState } from "react";
import { useParams } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";

import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { DownloadReportsResponseTypeApi } from "src/components/manufacturer/statsReports/types";
import { downloadExcelFile } from "src/helpers/downloadFile";
import {
    REPORT_DISPLAY_NAMES,
    REPORT_TITLES,
    ReportFilterStateActions,
    ReportFilterStateActionsType,
   
} from "./types";
import { initialState, tableFilterReducer } from "./reducer";
import ReportsFilter from "src/components/manufacturer/reportFilters";
import { ReportFilterState } from "src/components/manufacturer/reportFilters/types";
import GenericTable from "src/components/genericReport";
import PaginationNav from "src/components/actionDashboard/paginationNav";
import FooterText from "../../components/footerText";
import { AuthContext } from "src/context/authContext";
import { isZilrettaUser, normalizeDrugSelection } from "src/helpers";
import { getReportsByRole } from "src/constants";

const Reports: FC = (): JSX.Element => {

    const { userData } = useContext(AuthContext);
    const [queryParams, dispatch] = useReducer(tableFilterReducer, initialState(isZilrettaUser(userData)));
    const [enabledButton, setEnabledButton] = useState<boolean>(false);
    const { showToast } = useContext(ToastContext);

    const { setLoader, hideLoader } = useContext(LoaderContext);
    const [reportData, setReportsData] = useState<any>();

    const [totalPages, setTotalPages] = useState<number>();
    const [currentPages, setCurrentPages] = useState<number>();

    const { reportType } = useParams<{ reportType: string }>();
    let userReports = userData && getReportsByRole(userData);

    // check karna keah current reportType exist karta hai
    const currentReport =
        userReports?.find((r: any) => r.redirectLink === `/reports/${reportType}`) ||
        userReports?.[0]; // agar nahi mila to first report le lo
    // ab iske hisaab se title nikal lo
    const fullTitle =
        REPORT_TITLES[
        currentReport?.redirectLink.replace("/reports/", "") || ""
        ] || "Report";
    // const fullTitle = REPORT_TITLES[reportType || ""] || "Report";
    const displayTitle = REPORT_DISPLAY_NAMES[fullTitle] || fullTitle;

    // Fetch report download data
    const {
        data: downloadReportsData,
        error: downloadReportsError,
        mutate: downloadRequestForm,
        removeErrorAndData: clearRequestFileData,
    } = useFetch<DownloadReportsResponseTypeApi>(
        APIEndpoints.MANUFACTURE_STATISTICS_REPORT_DOWNLOAD,
        { ...queryParams, report_name: `${process.env.REACT_APP_ENV === "pre-production" ? "pre_" : ""}${displayTitle}` },
        {},
        false
    );


    useEffect(() => {
        console.log("DOWNLOAD REPORTS DATA OR ERROR CHANGED", { downloadReportsData, downloadReportsError });
        if (downloadReportsData || downloadReportsError) {
            if (downloadReportsData) {
                const { response, total_pages, current_page } = downloadReportsData;
                if (typeof response !== "string") {
                    setReportsData(response);
                    setTotalPages(total_pages);
                    setCurrentPages(current_page);
                    showToast(
                        ["Report preview created successfully"],
                        ToastTypes.SUCCESS
                    );
                }
                if (typeof response === "string") {
                    downloadExcelFile(response, `${displayTitle}.xlsx`);
                    showToast(["Report downloaded successfully"], ToastTypes.SUCCESS);
                }
            }
            hideLoader();
            setEnabledButton(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [downloadReportsData, downloadReportsError]);

    // Load report on reportType change
    useEffect(() => {
        console.log("REPORT TYPE CHANGED", reportType);
        const params = {
            ...queryParams,
            report_name: `${process.env.REACT_APP_ENV === "pre-production" ? "pre_" : ""}${displayTitle}`,
            file_required: false,
            drug_name: normalizeDrugSelection(userData, queryParams.drug_name, displayTitle),
            global_doctor_ids: "",
            practice_id: "",
            insurance_name:"",
            page:1
        };
        dispatch({
            type: ReportFilterStateActions.SET_QUERY_PARAMS,
            payload: params,
        });
        // const action: ReportFilterStateActionsType = {
        //     type: ReportFilterStateActions.CHANGE_PAGE,
        //     payload:  1,
        // };
        // dispatch(action);
        console.log("DISPATCHED PARAMS", params,queryParams);
        setLoader();
        downloadRequestForm({}, {}, params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportType]);

    const downloadReport = () => {
        const { page, pagination, ...remainingQueryParams } = queryParams;
        const params = {
            ...remainingQueryParams,
            report_name: `${process.env.REACT_APP_ENV === "pre-production" ? "pre_" : ""}${displayTitle}`,
            file_required: true,
            drug_name: normalizeDrugSelection(userData, queryParams.drug_name,displayTitle)
        };
        if (downloadReportsData || downloadReportsError) clearRequestFileData();
        setLoader();
        setEnabledButton(true);
        dispatch({
            type: ReportFilterStateActions.SET_QUERY_PARAMS,
            payload: params,
        });
        downloadRequestForm({}, {}, params);
    };

    const updateQueryParamsAndCallAPI = (updatedQueries: ReportFilterState): void => {
        console.log("UPDATE QUERY PARAMS CALLED WITH 👉", updatedQueries);
        const params = {
            ...updatedQueries,
            report_name: `${process.env.REACT_APP_ENV === "pre-production" ? "pre_" : ""}${displayTitle}`,
            file_required: false,
            drug_name: normalizeDrugSelection(userData, updatedQueries.drug_name,displayTitle)
        };
        dispatch({
            type: ReportFilterStateActions.SET_QUERY_PARAMS,
            payload: params,
        });
        setLoader();
        downloadRequestForm({}, {}, params);
    };

    const onPageChanged = (pageObj: { selected: number }) => {
        const action: ReportFilterStateActionsType = {
            type: ReportFilterStateActions.CHANGE_PAGE,
            payload: pageObj.selected + 1,
        };
        const newState = tableFilterReducer(queryParams, action);
        const params = {
            ...newState,
            report_name: `${process.env.REACT_APP_ENV === "pre-production" ? "pre_" : ""}${displayTitle}`,
            file_required: false,
            drug_name: normalizeDrugSelection(userData, queryParams.drug_name,displayTitle)
        };
        dispatch(action);
        setLoader();
        dispatch({
            type: ReportFilterStateActions.SET_QUERY_PARAMS,
            payload: params,
        });
        downloadRequestForm({}, {}, params);
    };

    return (
        <section className="reports-sec d-flex flex-column flex-fill overflow-auto">
            <div className="container-fluid pt-2 d-flex flex-column flex-fill">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                    <div className="d-flex align-items-center">
                        <h2 className="m-0 page-heading">Reports</h2>
                        &nbsp; | &nbsp;
                        <span className="fs-5 text-muted">{fullTitle}</span>
                    </div>
                    <div className="ms-auto">
                        <button className="btn btn-success" onClick={downloadReport} disabled={enabledButton}>
                            Download
                        </button>
                    </div>
                </div>
                <ReportsFilter
                    key={reportType || "defaultReportType"}
                    defaultQueryParams={queryParams}
                    updateQueryParams={updateQueryParamsAndCallAPI}
                />

                <div className="card table-card flex-fill">
                    {reportData && reportData.length > 0 ? (
                        <div className="card-body p-0 d-flex flex-column overflow-auto" style={{ flex: "1 1 0" }}>
                            <GenericTable data={reportData} />
                        </div>
                    ) : (
                        <div className="card-body p-0 d-flex flex-column align-items-center justify-content-center">
                            <p className="alert alert-warning p-2 text-center" style={{ minWidth: "300px" }}>
                                No Data Available
                            </p>
                        </div>
                    )}
                    {totalPages && totalPages > 1 && currentPages ? (
                        <PaginationNav
                            currentPage={currentPages}
                            pageCount={totalPages}
                            onPageChange={onPageChanged}
                        />
                    ) : null}
                </div>
            </div>
            <FooterText footerType="black" />
        </section>
    );
};

export default Reports;
